﻿<script>
	import { projectSettings } from "../config";
	import { regFormPhone } from "../tealium";
</script>

<header class="no-print">
	<div class="page-header">
		<div class="page-header-warp">
			<div class="page-header-container">
				<div class="page-header-components">
					<a href="https://shine.com.au" title="Shine Lawyers" target="_blank">
						<div class="logo">
							<img
								class="logo"
								src="https://images.ctfassets.net/20mp39y5r2lk/mAk30AlMHQ87xg6hwUA9y/09e406f0786a4a6853cbc29da2fb3692/Shine_Lawyers_Logo.svg"
								alt="Shine Lawyers" />
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</header>

<style>
	header {
		/*		margin-bottom: var(--height-header);
		margin-bottom: 40px;
*/
		transition: all 0.24s ease 0s;
	}

	header .page-header {
		width: 100vw;
		top: 0px;
		z-index: var(--z-index-top);
	}

	header .page-header-warp {
		background-color: var(--color-charcoal);
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		width: 100vw;
		height: var(--height-header);
	}

	header .page-header-container {
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	header .page-header-components {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		justify-content: space-between;
		width: 100%;
	}

	header .page-header-components a {
		color: inherit;
		text-decoration: none;
		outline: none;
	}

	header .logo {
		position: relative;
		margin-top: -3px;
		height: 45px;
		width: 100%;
	}

	header .logo img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	header .phone {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
	}

	header .phone a {
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		flex-direction: column;
		height: 100%;
		min-width: fit-content;
		color: var(--color-primary);
	}

	header .phone-icon {
		margin-right: 2px;
		width: 1rem;
		height: 1rem;
		min-width: 1rem;
		min-height: 1rem;
	}

	:global(header .phone-number a) {
		color: #fff;
	}

	@media (max-width: 1024px) {
		header .logo {
			height: 37px;
			width: 170px;
		}

		header .phone a {
			width: fit-content;
			margin: 20px 0px;
		}
	}

	@media (max-width: 400px) {
		header .page-header-container {
			padding: 0px 16px;
		}
	}
</style>
